define('Snapshot.CheckoutDocumentUpload', [
    'CheckoutDocumentUpload.View',
    'CheckoutDocumentUpload.Summary.View'
], function (
    CheckoutDocumentUploadView,
    CheckoutDocumentUploadSummaryView
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            var checkout = container.getComponent('Checkout');

            if (!checkout) { return; }

            checkout.addModuleToStep({
                step_url: 'shipping/address',
                module: {
                    id:        'document_upload_module',
                    index:     50,
                    classname: 'CheckoutDocumentUpload.View',
                    options:   {}
                }
            });

            checkout.addModuleToStep({
                step_url: 'review',
                module: {
                    id:        'document_upload_summary',
                    index:     15,
                    classname: 'CheckoutDocumentUpload.Summary.View',
                    options:   {}
                }
            });
        }
    };
});
